module.exports = __webpack_public_path__ + "assets/img/2021all-picture.61cc69e1.png";